import React from 'react';
import { useAuth } from '../AuthContext';
import { FaEnvelope, FaUser } from 'react-icons/fa';

const ProfileHighlight = ({ formData }) => {
  const { user } = useAuth();

  return (
    <div className="w-full mb-8 bg-[#fff8f5] rounded-lg p-6">
      <p className="text-xl font-semibold text-[#2a2e30] mb-2">
        <FaUser className="inline-block mr-2 text-[#FF5733]" />
        {formData.name || user?.name || 'Full Name'}
      </p>
      <hr className="border-t border-[#EDE4DA] my-4" />
      <p className="flex items-center text-[#2a2e30]">
        <FaEnvelope className="inline-block mr-2 text-[#FF5733]" />
        {formData.email || user?.email || 'Email Address'}
      </p>
    </div>
  );
};

export default ProfileHighlight;
